import { useLocale, useTranslations } from "use-intl";
import { useState } from "react";
import { Languages } from "lucide-react";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import { LOCALES, type Locale } from "@liftquest/shared/localized";

/** Which language version of user content is being edited. */
export function useEditLocale() {
  const locale = useLocale() as Locale;
  return useState<Locale>(locale);
}

export function EditLocaleToggle({ value, onChange }: { value: Locale; onChange: (l: Locale) => void }) {
  const t = useTranslations("common");
  const tl = useTranslations("languages");
  return (
    <div className="flex items-center justify-between gap-2 rounded-2xl border bg-muted/40 px-3 py-2">
      <span className="flex items-center gap-2 text-xs text-muted-foreground">
        <Languages className="size-4" /> {t("translate")}
      </span>
      <ToggleGroup
        type="single"
        size="sm"
        variant="outline"
        value={value}
        onValueChange={(v) => v && onChange(v as Locale)}
      >
        {LOCALES.map((l) => (
          <ToggleGroupItem key={l} value={l} className="px-2.5 text-xs">
            {tl(l)}
          </ToggleGroupItem>
        ))}
      </ToggleGroup>
    </div>
  );
}
